import Vue from "vue";
import VueRouter from "vue-router";
import routeJson from "./router.json";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 路由懒加载
const Test = () => import("../views/Home.vue");
const Mobile = () => import("../views/pages/mobile.vue");

const routesTemplate = [
  {
    path: "/IETips",
    name: "IETips",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/pages/IETips.vue"),
  },
  {
    path: "/details",
    name: "Details",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/template.vue"
      ),
  },
  {
    path: "/testHome",
    name: "testHome",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/test/index.vue"
      ),
  },
  {
    path: "/javatemplate",
    name: "Javatemplate",
    component: () => import("../views/pages/template/java/index.vue"),
  },
  {
    path: "/javatemplate_map",
    name: "Javatemplate_map",
    component: () => import("../views/pages/template/java/map.vue"),
  },
  {
    path: "/newMediaTemplate",
    name: "newMediaTemplate",
    component: () => import("../views/pages/template/newMedia/index.vue"),
  },

  {
    path: "/homejava1",
    name: "Homejava1",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/java-v1/index.vue"
      ),
  },
  {
    path: "/homejava2",
    name: "Homejava2",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/java-v1/index2.vue"
      ),
  },
  {
    path: "/homejava3",
    name: "Homejava3",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/java-v1/index3.vue"
      ),
  },
  //前端模板
  {
    path: "/homeweb",
    name: "Homeweb",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/web/index.vue"
      ),
  },
  {
    path: "/webTemplate",
    name: "webTemplate",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/web1/index.vue"
      ),
  },
  //python模板
  {
    path: "/homepython",
    name: "Homepython",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/python/index.vue"
      ),
  },
  //大数据模板
  {
    path: "/homebigdata",
    name: "Homebigdata",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/bigdata/index.vue"
      ),
  },
  //人工智能模板
  {
    path: "/homeai1",
    name: "Homeai1",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/ai/index.vue"
      ),
  },
  {
    path: "/homeai2",
    name: "Homeai2",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/ai2/index.vue"
      ),
  },
  {
    path: "/homeai3",
    name: "Homeai3",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/ai3/index.vue"
      ),
  },
  {
    path: "/aiNewTemplate",
    name: "AiNewTemplate",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/ai-new/index.vue"
      ),
  },
  {
    path: "/aiSubject",
    name: "AiSubject",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/ai-subject/index.vue"
      ),
  },
  {
    path: "/designTemplate",
    name: "designTemplate",
    component: () => import("../views/pages/template/design/index.vue"),
  },
  {
    path: "/pmTemplate",
    name: "pmTemplate",
    component: () => import("../views/pages/template/pm/index.vue"),
  },
];
const routes1 = [];
let routesArr = routeJson.data.pContents;
for (let item of routesArr) {
  for (let item1 of routesTemplate) {
    if (item.p_template && `/${item.p_template.code}` === item1.path) {
      routes1.push({
        path: `/${item.router}`,
        name: item.router,
        component: item1.component,
        meta: {
          name: item.subject.name ?? "",
        },
      });
    }
  }
}

const routes2 = [
  {
    path: "/test",
    name: "Test",
    component: Test,
  },
  {
    path: "/", // PC端首页
    redirect: { name: "Home" },
  },
  {
    path: "/mobile", // 手机端首页
    name: "Mobile",
    component: Mobile,
  },
  {
    path: "/detail",
    name: "Detail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/pages/dashboard.vue"),
  },
  {
    path: "/detail-test",
    name: "DetailTest",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/juhe.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/black",
    name: "Black",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/java/index.vue" //  "../views/pages/template/T003/black.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/eatManager",
    name: "EatManager",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/java/index.vue" // "../views/pages/template/T003/eatManager.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/detailss",
    name: "Detailss",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/template1.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/likede",
    name: "Likede",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/likede.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/ice",
    name: "Ice",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/ice.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/money",
    name: "Money",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/money.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/zhiwei",
    name: "Zhiwei",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/zhiwei.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/zhiniugu",
    name: "Zhiniugu",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/zhiniugu.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/health",
    name: "Health",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/health.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/suyun",
    name: "Suyun",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/suyun.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/ihrm",
    name: "Ihrm",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/ihrm.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/zhihui",
    name: "Zhihui",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/zhihui.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/saas",
    name: "Saas",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/saas.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/chong",
    name: "Chong",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/chong.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/buy",
    name: "Buy",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/buy.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/qing",
    name: "Qing",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/T003/qing.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  {
    path: "/tanhua",
    name: "Tanhua",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/java/index.vue"
      ),
    meta: {
      name: "java学科",
    },
  },
  //java首页
  {
    path: "/home",
    name: "Home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/home/index.vue"
      ),
  },
  //java主页
  {
    path: "/java",
    name: "Java",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ "../views/pages/javaClass.vue"),
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/java/index.vue"
      ),
  },
  // 前端主页
  {
    path: "/web",
    name: "Web",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/web/index.vue"
      ),
  },
  // python主页
  {
    path: "/python",
    name: "Python",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/python/index.vue"
      ),
  },
  {
    path: "/bishe",
    name: "bishe",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/bishe/index.vue"
      ),
  },
  // 大数据主页
  {
    path: "/bigdata",
    name: "Bigdata",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/bigdata/index.vue"
      ),
  },
  // 人工智能主页
  {
    path: "/ai",
    name: "Ai",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/ai/index.vue"
      ),
  },
  //人工智能详情页
  {
    path: "/aiDetails",
    name: "AiDetails",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/template/ai-subject/index.vue"
      ),
  },
  // 新媒体主页
  {
    path: "/nm",
    name: "newMedia",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/newMedia/index.vue"
      ),
  },
  // 产品主页
  {
    path: "/pm",
    name: "Pm",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/productManager/index.vue"
      ),
  },
  // 设计主页
  {
    path: "/ui-v1",
    name: "ui-v",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/design/index-v1.vue"
      ),
  },
  // 设计主页
  {
    path: "/ui",
    name: "ui",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/design/index.vue"
      ),
  },
  // 更新部分
  {
    path: "/homeUpdate",
    name: "homeUpdate",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pages/home/updatePorject/index.vue"
      ),
  },
  // // 这个路由请保持最底部，用来处理指定路由名称别名访问
  // {
  //   path: "*",
  //   component: () => import("@/router/index.vue"),
  // },
];
const routes = routes1.concat(routes2, routesTemplate);
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isIE =
    userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
  var isIE11 =
    userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  if ((isIE || isIE11) && to.path != "/IETips") {
    next("/IETips");
  }
  const items = [
    { id: "0", desc: "Home" },
    { id: "1", desc: "Java" },
    { id: "2", desc: "Web" },
    { id: "3", desc: "Python" },
    { id: "8", desc: "Ai" },
    { id: "7", desc: "Bigdata" },
    { id: "6", desc: "Ui" },
    { id: "5", desc: "Pm" },
    { id: "4", desc: "Detail" },
  ];
  const NavNameList = [
    "Home",
    "Java",
    "Web",
    "Bigdata",
    "Ai",
    "Python",
    "Ui",
    "Pm",
    "Detail",
  ];
  const metaNameList = [
    "java学科",
    "前端与移动开发",
    "大数据",
    "人工智能",
    "Python",
    "设计",
    "产品经理",
    "软件测试",
  ];
  if (NavNameList.indexOf(to.name) != -1) {
    sessionStorage.setItem("navIndex", NavNameList.indexOf(to.name));
    const id = items.filter((it) => it.desc == to.name)[0].id;
    sessionStorage.setItem("subjectID", id);
  } else if (to.meta.name && metaNameList.indexOf(to.meta.name) != -1) {
    sessionStorage.setItem("navIndex", metaNameList.indexOf(to.meta.name) + 1);
  }
  for (let item of routesArr) {
    if (to.path === `/${item.router}`) {
      sessionStorage.setItem("subjectID", item.subject.id);
      sessionStorage.setItem("detailsId", item.id);
    }
  }
  setTimeout(() => {
    next();
  }, 100);
});

// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g
//   const isChunkLoadFailed = error.message.match(pattern)
//   if(isChunkLoadFailed){
//     location.reload()
//   }
// })
export default router;
